/**
 * General Styles For The Layout
 * @type {function(*): {}}
 */
import { ArabicFont, EnglishFont } from '../../utils/Fonts'
import { fade } from '@material-ui/core'
import moment from 'moment'
import 'moment/locale/ar-ly'

export const useStyles = ((theme) => ({
  '@global': {
    html: { height: '100%' },
    body: {
      height: '100%',
      // direction: theme.direction,
      fontFamily: theme.direction === 'ltr' ? EnglishFont : ArabicFont,
      backgroundColor: theme.palette.colors.body
    },
    '#root': {
      height: '100%',
      whiteSpace: 'pre-line'
    },
    'a:not([role="button"])': {
      transition: 'all 0.3s ease-in-out',
      color: theme.palette.primary.main,
      '&:hover, &:focus': {
        color: theme.palette.secondary.main
      }
    },
    'button': {
      fontFamily: theme.direction === 'ltr' ? EnglishFont : ArabicFont,
      cursor: 'pointer',
      transition: 'all 0.3s ease-in-out',
      outline: 'none !important'
    },
    'img': {
      maxWidth: '100%',
      height: 'auto',
      display: 'inline-block'
    },
    'h1, h2, h3, h4, h5, h6': {
      fontFamily: theme.direction === 'ltr' ? EnglishFont : ArabicFont,
      fontWeight: 'bold'
    },
    '.MuiDrawer-paper': {
      backgroundColor: theme.palette.common.black
    },
    '.MuiBackdrop-root': {
      backgroundColor: fade(theme.palette.common.black, 0.75),
      backdropFilter: 'blur(2px)'
    },
    '::selection': {
      color: theme.palette.common.white,
      background: theme.palette.primary.main
    },
    '.listing-wrapper': {
      position: 'relative'
    },
    '.grecaptcha-badge': {
      visibility: 'hidden'
    },
    '.toasts-container': {
      width: 400,
      marginTop: theme.spacing(6),
      right: 0,
      [theme.breakpoints.up('lg')]: {
        width: 480
      }
    },
    '.rltv': {
      position: 'relative'
    },
    '.hidden': {
      display: 'none !important'
    },
    '.noWrap': {
      whiteSpace: 'nowrap'
    },
    '.required': {
      color: theme.palette.error.main,
      paddingRight: theme.spacing(0.25),
      paddingLeft: theme.spacing(0.25)
    },
    '.notification-close-button': {
      position: 'absolute',
      right: theme.spacing(2.5)
    },
    '.notification-progress-wrapper': {
      visibility: 'hidden'
    },
    '.notification-wrapper': {
      display: 'flex',
      alignItems: 'center',
      background: 'transparent',
      boxShadow: 'none',
      overflow: 'visible'
    },
    '.notification-component': {
      paddingRight: theme.spacing(4)
    },
    '.Toastify__toast': {
      direction: 'ltr',
      marginBottom: theme.spacing(0)
    },
    '.Toastify__toast-body': {
      flex: ' 1 1 auto',
      padding: theme.spacing(0)
    },
    '.MuiTooltip-tooltip': {
      fontSize: theme.typography.pxToRem(16)
    },
    '#confetti-wrapper': {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      pointerEvents: 'none',
      zIndex: 0
    },
    '.flip-direction': {
      transform: 'scaleX(-1)'
    },
    '.MuiPickersMonthSelection-container': {
      counterReset: 'section',
      '& .MuiPickersMonth-root': theme.direction === 'rtl' && {
        position: 'relative',
        visibility: 'hidden',
        '&:before': {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          visibility: 'visible'
        },
        '&:nth-child(1):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(0).format('MMMM').toString()}"`
        },
        '&:nth-child(2):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(1).format('MMMM').toString()}"`
        },
        '&:nth-child(3):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(2).format('MMMM').toString()}"`
        },
        '&:nth-child(4):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(3).format('MMMM').toString()}"`
        },
        '&:nth-child(5):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(4).format('MMMM').toString()}"`
        },
        '&:nth-child(6):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(5).format('MMMM').toString()}"`
        },
        '&:nth-child(7):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(6).format('MMMM').toString()}"`
        },
        '&:nth-child(8):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(7).format('MMMM').toString()}"`
        },
        '&:nth-child(9):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(8).format('MMMM').toString()}"`
        },
        '&:nth-child(10):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(9).format('MMMM').toString()}"`
        },
        '&:nth-child(11):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(10).format('MMMM').toString()}"`
        },
        '&:nth-child(12):before': {
          content: `"${moment().locale(theme.direction === 'rtl' ? 'ar-ly' : 'en-us').month(11).format('MMMM').toString()}"`
        }
      }
    }
  },
  pageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  content: {
    flex: '1 1 auto',
    transition: 'all 0.3s ease-in-out',
    paddingTop: theme.spacing(8),
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(12.25),
      '.shrink + &': {
        paddingTop: theme.spacing(10.75)
      }
    }

  }
}))
